import React from "react";
import withRouter from "../functional-hook-wrapper";
import styles from './navigation-banner.module.css';

export class NavigationBanner extends React.Component {
    state = {
        is_logged_in: localStorage.getItem('token')?.length,
        bannerText: "Kwik Fill Giveaway!"
    }

    router: any;

    constructor(props: any) {
        super(props);
        this.router = props.router;
    }

    componentDidMount() {
        // Temporarily commented out for Buffalo Bills announcement
        // this.fetchBannerText();
        
        // Set hardcoded banner text for Veterans Day
        this.setState({ bannerText: "In honor of Veterans Day, we're offering free shipping on all Operation Give Thanks merchandise orders through November 24th." });
    }

    // Temporarily commented out for Buffalo Bills announcement
    // private fetchBannerText() {
    //     fetch('https://kwik.burcs.workers.dev/query', {
    //         method: 'POST',
    //         headers: {
    //           'Authorization': 'Bearer 1b08552890094f86e6038a16d3b4d51a30aec0468565536e55c28e380f7488b2',
    //           'Content-Type': 'application/json'
    //         },
    //         body: JSON.stringify({
    //           sql: `
    //             SELECT
    //               id,
    //               json_extract(block_data, '$.blocks[1].data.text') AS paragraph_text
    //             FROM content
    //             WHERE id = 1 AND json_extract(block_data, '$.blocks[1].id') = 'mcOIRwhPyr'
    //           `
    //         })
    //     })
    //     .then(response => response.json())
    //     .then(data => {
    //         if (data && data.result && data.result.length > 0) {
    //             this.setState({ bannerText: data.result[0].paragraph_text || "Kwik Fill Giveaway!" });
    //         }
    //     })
    //     .catch(error => {
    //         console.error('Error fetching banner text:', error);
    //     });
    // }

    private getWelcomeMessage() {
        let name = localStorage.getItem('first_name');
        
        if (name) {
            return `Welcome, ${name}`
        }

        return 'Welcome'
    }

    private login() {
        window.history.pushState({}, null, '/account/login');
        this.router.navigate('/account/login');
    }

    private register() {
        window.history.pushState({}, null, '/account/register');
        this.router.navigate('/account/register');
    }

    private careers() {
        window.history.pushState({}, null, '/careers');
        this.router.navigate('/careers');
    }

    private kwikpay() {
        window.history.pushState({}, null, '/kwikpay');
        this.router.navigate('/kwikpay');
    }

    private stores() {
        window.history.pushState({}, null, '/stores');
        this.router.navigate('/stores');
    }

    private signOut() {
        localStorage.clear();
        window.location.href = '/'
    }

    render() {
        return (
            <div className={styles.container}>
                <div className={styles.left}>
                    <div className={styles.left_inner}>
                    <a 
                        href="https://www.operationgivethanks.com/merch.html" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className={styles.banner_link}
                    >
                        {this.state.bannerText}
                    </a>
                    </div>
                </div>

                { this.state.is_logged_in ?
                <>
                    <div className={styles.right}>
                        {/* <div className={styles.optional}> */}
                            <div onClick={() => { this.kwikpay() }} className={styles.navigation_item} style={{marginRight: 20}}>
                                <img className={styles.card_icon} style={{ display: 'inline-block', marginRight: 8, transform: 'translateY(4px)' }} src={`${process.env.PUBLIC_URL}/assets/navigation/credit-card.svg`}/>
                                KwikPAY
                            </div>
                            <div onClick={() => {
                                this.careers()
                            }} className={styles.navigation_item} style={{marginRight: 24}}>Careers</div>

                            <div onClick={() => { this.stores() }} className={styles.navigation_item} style={{marginRight: 24}}>Find a Store</div>

                            <div onClick={() => {
                                window.history.pushState({}, null, '/account');
                                this.router.navigate('/account');
                            }} className={styles.navigation_welcome}>{this.getWelcomeMessage()}</div>
                        {/* </div> */}
                    </div>

                    <div onClick={() => { this.signOut() }} className={styles.sign_in}>
                        Sign Out
                    </div>
                </>
                :
                <>
                    <div className={styles.right}>
                        <div onClick={() => { this.kwikpay() }} className={styles.navigation_item} style={{marginRight: 24}}>
                            <img className={styles.card_icon} style={{ display: 'inline-block', marginRight: 8, transform: 'translateY(4px)' }} src={`${process.env.PUBLIC_URL}/assets/navigation/credit-card.svg`}/>
                            KwikPAY
                        </div>
                        <div onClick={() => { this.careers() }} className={styles.navigation_item} style={{marginRight: 24}}>Careers</div>
                        <div onClick={() => { this.stores() }} className={styles.navigation_item} style={{marginRight: 24}}>Find a Store</div>
                        <div onClick={() => { this.register() }} className={styles.navigation_item} style={{marginRight: 0}}>Register</div>
                    </div>

                    <div onClick={() => { this.login() }} className={styles.sign_in}>
                        Sign In
                    </div>
                </>
                }
            </div>
        );
    }
}

export default withRouter(NavigationBanner);